import type ArrWaveform from './arrWaveform';
import EventEmitter from './event-emitter';
export type BasePluginEvents = {destroy: []};
export type GenericPlugin = BasePlugin<BasePluginEvents, unknown>;
export class BasePlugin<
  EventTypes extends BasePluginEvents,
  Options,
> extends EventEmitter<EventTypes> {
  protected arrwaveform?: ArrWaveform;
  protected subscriptions: (() => void)[] = [];
  protected options: Options;
  private isDestroyed = false;
  constructor(options: Options) {
    super();
    this.options = options;
  }
  protected onInit() {
    return;
  }
  public _init(arrwaveform: ArrWaveform) {
    if (this.isDestroyed) {
      this.subscriptions = [];
      this.isDestroyed = false;
    }
    this.arrwaveform = arrwaveform;
    this.onInit();
  }
  public destroy() {
    this.emit('destroy');
    this.subscriptions.forEach((unsubscribe) => unsubscribe());
    this.subscriptions = [];
    this.isDestroyed = true;
    this.arrwaveform = undefined;
  }
}
export default BasePlugin;
